import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inspirational-thoughts',
  templateUrl: './inspirational-thoughts.component.html',
  styleUrls: ['./inspirational-thoughts.component.scss']
})
export class InspirationalThoughtsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
